import styled from '@app/styled';
import { color, spacing } from '@app/theme';

export const ExportContainer = styled.div`
    padding: ${spacing(2, 4)};
    background-color: ${color('custom.surface.secondary')};
`;
